import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React, { Component } from 'react';
import classNames from 'classnames';
import Heading from "@scentregroup/ui/components/heading";
import Container from "@scentregroup/ui/components/container";
import Paragraph from "@scentregroup/ui/components/paragraph";
import { matchMedia, breakpointTabletQuery } from '../../helpers/match-media';
import StarRating from '../star-rating';
import analyticsUtils from '../../helpers/analytics-utils';
import { lazyloadWrapper } from '../../helpers/lazyload-wrapper';
import { reviewsType } from './types';
import ReviewList from './review-list';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class Reviews extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "gridSizeChanged", event => {
      this.setState({
        isTabletOrSmaller: event.matches
      });
    });
    _defineProperty(this, "trackModuleImpression", () => {
      analyticsUtils.gaTagTracking({
        event: analyticsUtils.events.MODULE_IMPRESSION,
        eventCategory: analyticsUtils.categories.USER_GENERATED_CONTENT,
        eventAction: analyticsUtils.actions.REVIEWS_MODULE_SHOW
      });
    });
    _defineProperty(this, "trackModuleClick", () => {
      analyticsUtils.gaTagTracking({
        event: analyticsUtils.events.USER_CLICK,
        eventCategory: analyticsUtils.categories.USER_GENERATED_CONTENT,
        eventAction: analyticsUtils.actions.REVIEWS_SEE_MORE
      });
    });
    this.tabletMatchMedia = matchMedia(breakpointTabletQuery);
    const isTabletOrSmaller = this.tabletMatchMedia.matches;
    this.state = {
      isTabletOrSmaller
    };
  }
  componentDidMount() {
    this.trackModuleImpression();
    this.tabletMatchMedia.addListener(this.gridSizeChanged);
  }
  componentWillUnmount() {
    this.tabletMatchMedia.removeListener(this.gridSizeChanged);
  }
  render() {
    const {
      title,
      rating,
      count,
      entries,
      centreTitle
    } = this.props;
    const {
      isTabletOrSmaller
    } = this.state;
    if (!rating || !count) {
      return null;
    }
    const basedText = isTabletOrSmaller ? 'Based on' : null;
    const starRating = /*#__PURE__*/_jsx(Paragraph, {
      className: style.starRating,
      "data-id": "reviews_index_starRating_Paragraph",
      children: /*#__PURE__*/_jsx(StarRating, {
        starRating: Math.floor(rating),
        starTotal: 5,
        "data-id": "reviews_index_starRating_Paragraph_StarRating"
      })
    });
    return /*#__PURE__*/_jsxs(Container, {
      centred: true,
      type: "large",
      className: classNames(style.container),
      "data-id": "reviews_index_starRating_Container",
      children: [/*#__PURE__*/_jsx(Heading, {
        "data-test-id": "reviews-heading",
        type: "large",
        className: style.heading,
        "data-id": "reviews_index_starRating_Container_Heading",
        children: title
      }), /*#__PURE__*/_jsxs("div", {
        className: style.reviews,
        "data-id": "reviews_index_starRating_Container_div",
        children: [/*#__PURE__*/_jsxs("div", {
          className: style.summary,
          "data-id": "reviews_index_starRating_div_div_5",
          children: [/*#__PURE__*/_jsxs(Paragraph, {
            className: style.averageWrapper,
            "data-id": "reviews_index_starRating_div_Paragraph",
            children: [/*#__PURE__*/_jsx("span", {
              className: style.score,
              "data-id": "reviews_index_starRating_Paragraph_span",
              children: rating
            }), ' average ']
          }), isTabletOrSmaller && starRating, /*#__PURE__*/_jsxs("div", {
            className: style.summaryDetails,
            "data-id": "reviews_index_starRating_div_div",
            children: [/*#__PURE__*/_jsxs(Paragraph, {
              className: style.basedText,
              "data-id": "reviews_index_starRating_div_Paragraph",
              children: [basedText, " ", count, " reviews & ratings"]
            }), !isTabletOrSmaller && starRating]
          })]
        }), /*#__PURE__*/_jsx("div", {
          "data-test-id": "review-list-wrapper",
          className: style.reviewListWrapper,
          "data-id": "reviews_index_starRating_div_div",
          children: /*#__PURE__*/_jsx(ReviewList, {
            centreTitle: centreTitle,
            reviews: entries,
            "data-id": "reviews_index_starRating_div_ReviewList"
          })
        })]
      })]
    });
  }
}
export const RawReviews = Reviews;
export default lazyloadWrapper(RawReviews);